
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyDQrHLwo2U_eQs8j92EroysvBIKjEfHdvk",
  authDomain: "nexority-4772b.firebaseapp.com",
  projectId: "nexority-4772b",
  storageBucket: "nexority-4772b.firebasestorage.app",
  messagingSenderId: "955641147800",
  appId: "1:955641147800:web:b03b2b1a6edb28f6323bed",
  measurementId: "G-QV1ZTX6S1B"
};

const app = initializeApp(firebaseConfig);
const firbaseAuth  = getAuth(app);
export { app, firbaseAuth };